import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";

import LandingPage from "./pages/LandingPage";
import Navbar from "./components/NavBar";
import ChatWidget from "./components/ChatWidget";
import AboutUs from "./pages/AboutUs";
import ErrorPage from "./pages/ErrorPage";
import CoursesPage from "./pages/CoursesPage";
import ContactUsPage from "./pages/ContactUsPage";
import ProductsPage from "./pages/ProductsPage";
import ServicesPage from "./pages/ServicesPage";
import ProductDetailsPage from "./pages/ProductDetailsPage";
import StorePage from "./pages/StorePage";
import CheckoutPage from "./pages/CheckoutPage";
import Bookslot from "./pages/Bookslot";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import AdminLayout from "./admin/AdminLayout";
import WorkshopPage from "./pages/WorkshopPage";
import GalleryPage from "./pages/GalleryPage";

function AppRoutes() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      {/* Hide navbar and assistant on admin routes */}
      {!isAdminRoute && (
        <>
          <Navbar />
          <ChatWidget />
        </>
      )}

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/contact_us" element={<ContactUsPage />} />
        {/* <Route path="/products" element={<ProductsPage />} /> */}
        {/* <Route path="/store" element={<StorePage />} /> */}
        {/* <Route path="/checkout" element={<CheckoutPage />} /> */}
        {/* <Route path="/product-details" element={<ProductDetailsPage />} /> */}
        <Route path="/bookslot" element={<Bookslot />} />
        {/* <Route path="/workshop" element={<WorkshopPage />} /> */}
        <Route path="/gallery" element={<GalleryPage />} />


        {/* Admin routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="login" element={<AdminLogin />} />
          <Route path="dashboard" element={<AdminDashboard />} />
        </Route>

        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}
